import React from "react";
import "../../Styles/certified/idea.css";

export default function Finzly() {
  return (
    <>
      <div className="idea-certified-details-section">
        <div className="idea-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="idea-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="idea-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="idea-certified-badge"
            />
            <div className="idea-certified-company-names">
              <a href="https://ideassion.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/idea/idea.png"
                alt="Walkzero Logo"
                className="idea-certified-company-logo"
              />
            </a>
              <h1 className="idea-certified-full-name">
              Ideassion Technology Solutions Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="idea-certified-details-right">
            <img
              src="/assets/idea/idea_1.jpeg"
              alt="Finzly Office"
              className="idea-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="idea-certified-description">
          <h2>
            Why Ideassion Technology Solutions Pvt Ltd is an Outstanding Workplaces
          </h2>
          <p>
            Ideassion partners with organisations at the start of their transformation journey and works across the enterprise, strategy, platforms, processes, data, and experience to automate value creation and turn digital platforms into scalable, revenue-generating engines. We design and deliver holistic digital transformation programs that modernise legacy systems, break down silos, improve customer experience, strengthen digital trust, and enable faster, smarter decision-making. Trusted by SMEs and growing enterprises to deliver practical, outcome-driven digital transformation, from vision to implementation.

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="idea-certified-info-cards">
          <div className="idea-certified-info-card">
            <div className="idea-certified-info-title">COMPANY SIZE</div>
            <div className="idea-certified-info-value">120 Employees</div>
          </div>
          <div className="idea-certified-info-card">
            <div className="idea-certified-info-title">INDUSTRY</div>
            <div className="idea-certified-info-value">IT Services

</div>
          </div>
          <div className="idea-certified-info-card">
            <div className="idea-certified-info-title">CONNECT</div>
            <div className="idea-certified-info-icons">
              <span className="idea-certified-icon-round">
                <a href="https://ideassion.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="idea-certified-icon-round">
                <a href="https://www.linkedin.com/company/ideassion/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="idea-certified-icon-round">
                <a href="https://www.facebook.com/ideassion" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="idea-certified-info-card">
            <div className="idea-certified-info-title">LOCATION (HQ)</div>
            <div className="idea-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="idea-certified-recognition-section">
          <h2 className="idea-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="idea-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="idea-certified-recognition-image"
            />
          </div>
          <div className="idea-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="idea-certified-life-section">
          <h2 className="idea-certified-life-title">
            Life at Ideassion Technology Solutions Pvt Ltd 
          </h2>
          <div className="idea-certified-life-gallery">
            <div className="idea-certified-life-col">
              <img src="/assets/idea/idea_1.jpeg" alt="Office 1" className="idea-certified-life-img" />
              <img src="/assets/idea/idea_2.jpeg" alt="Team 1" className="idea-certified-life-img" />
            </div>
            <div className="idea-certified-life-col idea-certified-life-center">
              <img src="/assets/idea/idea_3.jpeg" alt="Main Office" className="idea-certified-life-img idea-certified-life-img-large" />
            </div>
            <div className="idea-certified-life-col">
              <img src="/assets/idea/idea_4.jpeg" alt="Office 2" className="idea-certified-life-img" />
              <img src="/assets/idea/idea_2.jpeg" alt="Team 2" className="idea-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
